module.exports = "/images/applications-hub-icon.svg?d27dc8079ca7ce2ea0f485fd18dc518a";